//import anime from 'animejs';
//import Letterize from 'letterizejs';
import { gsap } from 'gsap' ;
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
  init() {
   
    
  
    $('#quitar-mute').click( function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').click( function (){
      $('video').prop('muted', true);
      $('#quitar-mute').css('display','block');
      $('#mute-video').css('display','none');
    });

    $('.contKidsweek').on('click', function(){
      console.log('accedo');
      window.open('/entradas');
    });

    var altura = $('.banner').offset().top;
   

   
    $(window).on('scroll', function(){
      if ( $(window).scrollTop() > altura ){
       
        $('.banner').addClass('menu-fixed');

      } else {
        $('.banner').removeClass('menu-fixed');
        
      }
    });

    gsap.registerPlugin(ScrollTrigger, CSSPlugin, TextPlugin, ScrollToPlugin);



  /*
      var tl = gsap.timeline({});
   
        tl.to('#quieroReir', {opacity: 1, duration: 1, width: '90%', ease: 'elastic'});
        tl.to('#quieroReir', {opacity: 0, width: 0, duration: 1});
        tl.to('#quieroBailar', {opacity: 1, duration: 1, width: '90%', ease: 'elastic'});
        tl.to('#quieroBailar', {opacity: 0, width: 0,duration: 1});
        tl.to('#quieroLentejuelas', {opacity: 1, duration: 1, width: '90%', ease: 'elastic'});
        tl.to('#quieroLentejuelas', {opacity: 0, width: 0,duration: 1});
        tl.to('#quieroCampanolos', {opacity: 1, duration: 1, width: '90%', ease: 'elastic'});
        tl.to('#siQuiero', {opacity: 1, duration: 1, ease: 'elastic'});
        tl.to('#quieroCampanolos', {opacity: 0, width: 0,duration: 1});
      
      tl.to('#invitacionBoda', {opacity: 1, duration: 0.1, ease: 'elastic'});
      tl.to('.teatroInicio', {opacity: 1, duration: 0.1, ease: 'elastic'});
      tl.play();
*/

    let miGiro = gsap.to('.luzGirandoUno', {rotation: 360, duration: 5, ease: 'none', repeat: -1});

    miGiro.play();

/*
    let animacionBanner = gsap.timeline({repeat: -1});

    console.log( window.innerWidth  );

    animacionBanner.fromTo('.texto-promo', {x: '50vw' }, { duration: 20,  ease: 'none', x: () => - window.innerWidth});

    animacionBanner.play();

    $('.promo-header').on('mouseover',function(){
      animacionBanner.pause();
    })
    $('.promo-header').on('mouseout',function(){
      animacionBanner.play();
    })
*/
    /*const tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: '#divCanciones',
        start: 'center center ',
        end: 'bottom bottom',
        scrub: true,
        markers: true,
      },
    });
    tl1.to('.imgCoche', {left: '10%', duration: 3});*/

    const isMobileSinopsis = window.matchMedia('(max-width: 768px)').matches;

    if (isMobileSinopsis) {
      gsap.set('.primeraZona', { top: 0 });
      gsap.set('.luzGirandoUno', { opacity: 1 });
      gsap.set('.contTextSinopsis', { opacity: 1 });
      gsap.set('#carreteraSuperior', { top: '19.5%', opacity: 0 });
    }

     const tl3 = gsap.timeline({
      scrollTrigger: {
        trigger: '#sinopsisSup',
        start: 'top center',
        end: 'center 90%',
        scrub: true,
        markers: false,
      },
    });
    if (!isMobileSinopsis) {
      tl3.to('.primeraZona',{top: 0 , duration: 1});
      tl3.to('.luzGirandoUno',{opacity: 1 , duration: 1});
    }
    if (isMobileSinopsis) {
      tl3.set('#carreteraSuperior', { opacity: 1 });
    } else {
      tl3.to('#carreteraSuperior',{top: '19.5%' , duration: 2});
      tl3.to('.contTextSinopsis',{opacity: 1 , duration: 1});
    }

    tl3.to('#carreteraInferior',{opacity: 1 , duration: 1});
    tl3.to('#flor_sup_1',{width: '11%' , duration: 1});
    tl3.to('#flor_sup_2',{width: '8%' , duration: 1});
    tl3.to('#flor_sup_3',{width: '5%' , duration: 1});
    tl3.to('#flor_sup_4',{width: '4%' , duration: 1});
    tl3.to('.imgCocheSinopsis',{right: '31%' , duration: 1});
    tl3.to('.imgChiquititaSinopsis',{right: '6.5%' , duration: 1});
    tl3.to('#chiquititaBrillo',{opacity: 1 , duration: 1});







    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: '#sinopsisInf',
        start: '-25% center',
        end: '5% 70%',
        scrub: 2,
        markers: false,
      },
    });
    tl2.to('#curvasFinales', {opacity: 1 ,  duration: 2})
    tl2.to('.contIntSinopsisInf', {opacity: 1, duration: 0.5})
    tl2.to('.imgSuperTruperAzul', {left: '5%' ,  duration: 0.5})
    tl2.to('#superTruperBrillantina', {opacity: 1, duration: 0.5})
    tl2.to('.imgHoneyHoneyAzul', {width: '19%', duration: 0.5})
   tl2.to('#ourLastSummer', {right: '1%', duration: 0.5})
    tl2.to('#honeyHoneyBrillantina', {opacity: 1, duration: 0.5})
    tl2.to('.contAyuda', {opacity: 1, duration: 0.5});

    tl2.to('.siluetaFinal', {bottom: '-5%', duration: 0.5});



    if ($('#btnMedios').length && $('#btnEspectadores').length) {
      $('#btnMedios').on('click', function (){
        $(this).addClass('botonactivo');
        $('#btnEspectadores').removeClass('botonactivo');
        $('#EspectadoresCont').css('display', 'none');
        $('#MediosCont').css('display', 'block');
      });

      $('#btnEspectadores').on('click', function (){
        $(this).addClass('botonactivo');
        $('#btnMedios').removeClass('botonactivo');
        $('#MediosCont').css('display', 'none');
        $('#EspectadoresCont').css('display', 'block');
      });
    }


/*
    let moveSlide = gsap.timeline({
      repeat: -1,
      repeatDelay: 5,
    });

    moveSlide.to('.headerCont',{opacity: 0, duration: 0.5, delay: 5})
    moveSlide.to('.contKidsweek',{opacity: 1, zIndex: 999});
    
*/

   


    const $opiniones = $('#opiniones');
    const estadosOpiniones = ['slide1', 'slide2'];
    const estadosDisponibles = estadosOpiniones.filter((estado) => $opiniones.find(`li.${estado}`).length);

    function mostrarEstadoOpiniones(estado) {
      if (!$opiniones.length) {
        return;
      }

      const $itemsOpiniones = $opiniones.find('li.slide1, li.slide2');
      if (!$itemsOpiniones.length) {
        return;
      }

      $itemsOpiniones.stop(true, true).hide();

      const $estadoActivo = $opiniones.find(`li.${estado}`);
      if ($estadoActivo.length) {
        $estadoActivo.stop(true, true).fadeIn('slow');
      }
    }

    function iniciarCarruselOpiniones() {
      if (!$opiniones.length || !estadosDisponibles.length) {
        return;
      }

      let indiceEstado = 0;

      mostrarEstadoOpiniones(estadosDisponibles[indiceEstado]);

      setTimeout(() => {
        setInterval(() => {
          indiceEstado = (indiceEstado + 1) % estadosDisponibles.length;
          mostrarEstadoOpiniones(estadosDisponibles[indiceEstado]);
        }, 5000);
      }, 3000);
    }

    iniciarCarruselOpiniones();

    const frases = $('.marquesina-frase');
    const $contenedor = $('.promo-header');
    const anchoContenedor = $contenedor.width();
    const duracion = 8000; // duración de cada animación
    const solape = 2000;   // solape en milisegundos
    let index = 0;

    // function animarFrase() {
    //   const actual = frases.eq(index);
    //   const anchoActual = actual.outerWidth();
    
    //   actual.css({
    //     left: anchoContenedor,
    //     display: 'block',
    //     zIndex: 1,
    //   });
    
    //   actual.animate(
    //     { left: -anchoActual },
    //     duracion,
    //     'linear',
    //     function () {
    //       $(this).hide();
    //     }
    //   );
    
    //   const siguienteIndex = (index + 1) % frases.length;
    //   index = siguienteIndex;
    
    //   setTimeout(animarFrase, duracion - solape);
    // }

    function animarFrase() {
      if (!frases.length || !$contenedor.length) {
        return;
      }

      const actual = frases.eq(index).get(0);
      if (!actual) {
        return;
      }

      const anchoActual = actual.offsetWidth || actual.getBoundingClientRect().width || 0;

      actual.style.left = anchoContenedor + 'px';
      actual.style.display = 'block';
      actual.style.zIndex = 1;

      const desde = anchoContenedor;
      const hasta = -anchoActual;
      const inicio = performance.now();

      function paso(timestamp) {
        const progreso = Math.min((timestamp - inicio) / duracion, 1);
        const nuevaPos = desde + (hasta - desde) * progreso;
        actual.style.left = `${nuevaPos}px`;

        if (progreso < 1) {
          requestAnimationFrame(paso);
        } else {
          actual.style.display = 'none';
        }
      }

      requestAnimationFrame(paso);

      index = (index + 1) % frases.length;

      setTimeout(animarFrase, duracion - solape);
    }

    animarFrase();
   
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js